export default "__VITE_ASSET__Dik4kG4D__"